import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useAuthenticator } from "@aws-amplify/ui-react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ContentLayoutFooterNoChartreuse from "components/Layout/ContentLayoutFooterNoChartreuse";
import TrackingComponent from "../components/Tracking";

function Track() {
  const router = useRouter();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  useEffect(() => {
    if (authStatus === "unauthenticated") {
      router.push("/login");
    }
  }, [authStatus, router]);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <ContentLayoutFooterNoChartreuse title="Orders">
      <div
        className={
          isSmallScreen
            ? "w-full px-2 pt-16 flex items-center"
            : "w-full px-20 py-16 flex items-center"
        }
      >
        <TrackingComponent />
      </div>
    </ContentLayoutFooterNoChartreuse>
  );
}

export default Track;

export async function getStaticProps() {
  return {
    props: { page: "Track" },
  };
}
